module.exports = __webpack_public_path__ + "media/images/black_history_month/video-text-04b9e5b2d1c35ce1e892dcb7022dbd35.svg";